import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {EndpointsService} from '../../../services/endpoints.service';
import {HttpApiService} from '../../../services/http-api.service';
import {UserService} from '../../../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../services/shared.service';
import {ModalDirective} from 'ngx-bootstrap';
import {URLSearchParams} from '@angular/http';
import {Constants} from '../../../services/constants';

import {DomSanitizer} from '@angular/platform-browser';
import {ProfilesService} from '../../../services/profiles.service';
import {AlertMessageComponent, AlertType} from '../../../shared/alert-message/alert-message.component';

@Component({
  selector: 'app-create-lead',
  templateUrl: './create-lead.component.html',
  styleUrls: ['./create-lead.component.scss']
})
export class CreateLeadComponent implements OnInit {

  lead: any = {
    vendor: '', vendorName: 'UN-AVAILABLE',
    department: '', address: {city: '', country: '', state: ''},
    appProfile: {}, date: Date.now(),
    buyer: {}
  };
  newRow: any = {};
  partnerEmail = Constants.SAASMAX_PARTNER_EMAIL();
  profiles: Array<any>;
  user: any = {};
  errorMessage: any;
  viewMode: any;
  leadOptions: [{ id: 0, name: 'New Customer for Product' },
    { id: 1, name: 'Existing Customer' },
    { id: 2, name: 'New Department/Division' },
    { id: 3, name: 'Digital Lead' }];
  selectedItems = [];
  optionsModel: any = {leadOptions: [], leadTypes: []};
  rfqData;
  isCustomerSelected = false;
  isQuoteWithoutRFQ = true;
  tempProxyBuyer;
  emailHref;
  requestRFQ;
  selectedAddOnItems = [];
  addOnOptions: Array<any>;
  addOnsModel: any = {addOnOptions: [], addOnTypes: []};
  @Input('quoteId') quoteId;
  @Input('leadId') leadId;
  @Input('isViewOnly') isViewOnly;
  @Input('requestForRFQ') requestForRFQ;
  @Output() rfqStatus: EventEmitter<any> = new EventEmitter();
  @Input() newRfq = false;
  @ViewChild('userModal') public userModal: ModalDirective;
  @ViewChild('userDisplayModal') public userDisplayModal: ModalDirective;

  isUploading = false;

  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  @ViewChild('modal') public modal: ModalDirective;


  constructor(private api: HttpApiService,
              private endpoints: EndpointsService,
              private router: Router,
              private sharedService: SharedService,
              private route: ActivatedRoute,
              private userService: UserService,
              private profileService: ProfilesService,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.isUploading = true;
    this.emailHref = this.sanitizer.bypassSecurityTrustResourceUrl('mailto:' + this.partnerEmail);
    this.viewMode = this.isViewOnly;
    this.leadOptions = [{id: 0, name: 'New Customer for Product'},
      {id: 1, name: 'Existing Customer'},
      {id: 2, name: 'New Department/Division'},
      {id: 3, name: 'Digital Lead'}];
    if (!this.newRfq) {
      this.rfqData = this.sharedService.getParameter('selectedRFQ');
      if (this.rfqData) {
        this.populateData(this.rfqData);
        this.isQuoteWithoutRFQ = false;
      } else {
        if (this.sharedService.getParameter('selectedLead')) {
          this.populateData(this.sharedService.getParameter('selectedLead'));
        } else {
          this.populateData(null);
        }
      }
    } else {
      this.rfqData = {};
      this.populateData(null);
      this.sharedService.setParameter('selectedRFQ', null);
    }
    if (!this.lead.buyer.id) {
      this.isCustomerSelected = false;
    } else {
      this.isCustomerSelected = true;
    }
  }

  populateData(rfqObject) {
    this.isUploading = true;
    if (rfqObject) {
      this.lead = rfqObject;
      this.lead.appProfile = this.lead.appProfile ? this.lead.appProfile : this.lead.applicationProfile;
      this.selectedItems = this.lead.leadTypes = this.lead.leadTypes ? this.lead.leadTypes : this.lead.quoteTypes ;
      if (this.lead.leadTypes) {
        this.lead.leadTypes.forEach(
          item => {
            if (item.id) {
              this.optionsModel.leadTypes.push({id: this.leadOptions[item.id].id});
            } else {
              this.optionsModel.leadTypes.push({id: this.leadOptions[item].id});
            }
          }
        );
      }
      if (this.lead.addOns) {
        this.addOnOptions = [];
        this.lead.addOns.forEach(
          item => {
            if (item.id) {
              this.addOnOptions.push({id: item.id, name: item.name});
              this.addOnsModel.addOnTypes.push({id: item.id, name: item.name});
            }
          }
        );
      }
    }
    if (!(this.lead.user)) {
      this.lead.user = this.userService.getCurrentUser();
      this.lead.user = this.lead.user.__zone_symbol__value;
    }

    this.api.get(this.endpoints.getCurrentUserProfiles(), true).subscribe(data => {
      this.lead.apps = data;
      for (const key in this.lead.apps) {
        if (this.lead.apps.hasOwnProperty(key) && this.lead.apps[key].id === this.lead.appProfile.id) {
          this.lead.appProfile = this.lead.apps[key];
        }
        this.isUploading = false;
      }});
    this.profileService.getAllProfiles();
    if (this.lead.appProfile) {
      this.lead.selectedPricingPlan = this.lead.pricingPlan;
      this.onChangeProduct();
    }
    if (this.sharedService.getParameter('createRFQ') && !this.sharedService.getParameter('editMode')) {
      this.requestRFQ = this.sharedService.getParameter('selectedRFQ');
      this.onChangeProduct();
    }
    this.sharedService.setParameter('selectedLead', null);
    this.sharedService.setParameter('selectedRFQ', null);
    this.lead.date = this.lead.dateCreated ? this.lead.dateCreated : new Date();
  }


  createLead() {
    this.isUploading = true;
    this.errorMessage = null;
    this.lead.leadTypes = this.selectedItems;
    this.lead.vendorApprovalRequired = this.lead.vendorApprovalRequired ? this.lead.vendorApprovalRequired : 'NO';
    if (this.validateLead(this.lead)) {
      if (this.requestForRFQ) {
        if (this.requestRFQ) {
          this.lead.requestForQuote = {id: this.requestRFQ.id};
        }
        this.lead.quoteTypes = this.lead.leadTypes;
        this.lead.applicationProfile = this.lead.appProfile;
        this.lead.addOns = this.selectedAddOnItems;
        this.createNewQuote(this.lead);
      } else {
        if (!this.leadId) {
          this.lead.vendorApprovalStatus = 'PENDING';
          if (this.requestRFQ) {
            this.lead.requestForQuotation = {id: this.requestRFQ.id};
          }
          this.api.post(this.endpoints.getLeadsUrl(), this.lead, true)
            .subscribe(response => {
                this.rfqStatus.emit(true);
                this.sharedService.leadStatusSubject.next(true);
                this.isUploading = false;
                AlertMessageComponent.open(AlertType.Success, 'Lead Registration Form Submitted Successfully');
              },
              error => {
                this.isUploading = false;
                AlertMessageComponent.open(AlertType.Error, 'Lead Registration Failure');
                this.errorMessage = error;
              });
        } else {
          this.api.put(this.endpoints.getLeadUrl() + '/' + this.lead.id, this.lead, true)
            .subscribe(response => {
                this.rfqStatus.emit(true);
                this.sharedService.leadStatusSubject.next(true);
                this.isUploading = false;
                AlertMessageComponent.open(AlertType.Success, 'Lead Registration Form Submitted Successfully');
              },
              error => {
                this.isUploading = false;
                AlertMessageComponent.open(AlertType.Error, 'Lead Registration Failure');
                this.errorMessage = error;
              });
        }
      }
    } else {
      AlertMessageComponent.open(AlertType.Error, 'Please complete lead registration form');
    }
  }

  validateLead(lead) {
    let isValid = true;
    if (!lead.preferredResellerProgram || lead.preferredResellerProgram === '') {
      AlertMessageComponent.open(AlertType.Error, 'Please Select Reseller Program');
      isValid = false;
    }

    const buyer = lead.buyer;

    if (!buyer.user) {
      AlertMessageComponent.open(AlertType.Error, 'Please Select Customer');
    }
    if (lead.purchaseTimeEstimate === '') {
      AlertMessageComponent.open(AlertType.Error, 'Please Select Purchase Time Estimate');
      isValid = false;
    }
    if (!lead.appProfile) {
      AlertMessageComponent.open(AlertType.Error, 'Please Select Application Product Name');
      isValid = false;
    }
    if (!lead.leadTypes) {
      AlertMessageComponent.open(AlertType.Error, 'Please Select Type Of Leads');
      isValid = false;
    }
    if (!isValid) {
      this.isUploading = false;
    }
    return isValid;
  }

  createNewQuote(data) {
    data = this.createRFQObject(data);
    if (!this.quoteId) {
      this.api.post(this.endpoints.getRFQUrl('tenantId=' + Constants.TENANT_ID()), data, true)
        .subscribe(res => {
            this.resetValues();
            this.isUploading = false;
            AlertMessageComponent.open(AlertType.Success, 'Your Quote Request has been successfully submitted');
            this.router.navigateByUrl('/buyer/commerce');
          },
          error => {
            this.isUploading = false;
            const errorBody = JSON.parse(error._body);
            if (errorBody && errorBody.message) {
              this.errorMessage = errorBody.message;
            } else {
              this.errorMessage = 'Reason unknown!';
            }
          });
    } else {
      this.api.put(this.endpoints.getRequestForQuoteUrl() + '/' + data.id, data, true)
        .subscribe(res => {
            this.resetValues();
            this.isUploading = false;
            AlertMessageComponent.open(AlertType.Success, 'Your Quote Request has been successfully submitted');
            this.router.navigateByUrl('/buyer/commerce');
          },
          error => {
            this.isUploading = false;
            const errorBody = JSON.parse(error._body);
            if (errorBody && errorBody.message) {
              this.errorMessage = errorBody.message;
            } else {
              this.errorMessage = 'Reason unknown!';
            }
          });
    }
  }


  createRFQObject(data) {
    const rfqObject = {
      id: data.id,
      isRespondToRFP: data.isRespondToRFP,
      applicationProfile: data.applicationProfile,
      submissionDeadline: data.submissionDeadline,
      pricingPlanType: data.pricingPlanType,
      pricingTier: data.pricingTier,
      requestNo: data.requestNo,
      purchaseTimeEstimate: data.purchaseTimeEstimate,
      productUsers: data.productUsers,
      buyer: data.buyer,
      addOns: data.addOns,
      quoteTypes: data.quoteTypes,
      preferredResellerProgram: data.preferredResellerProgram,
      requestForQuote: data.requestForQuote,
      otherRequirements: data.otherRequirements
    };
    return rfqObject;
  }

  resetValues() {
    this.errorMessage = null;
    this.rfqStatus.emit(true);
  }

  dateSelected(date) {
    this.lead.expectedPurchaseDate = new Date(date).getTime();
  }

  updateSelectedItems() {
    this.selectedItems = [];
    for (const key in this.optionsModel.leadOptions) {
      if (this.optionsModel.leadOptions.hasOwnProperty(key)) {
        this.selectedItems.push(this.optionsModel.leadOptions[key].id);
      }
    }
  }

  onChangeProduct() {
   // this.getCustomers(this.lead.buyer.user);
    this.lead.pricingPlans = [];
    if (this.lead.appProfile.details || this.lead.detailId) {
      const detailId = this.lead.appProfile.details ? this.lead.appProfile.details.id : this.lead.detailId
      this.api.get(this.endpoints.getSpecificPricingPlansUrl() + '?detailId=' + detailId, true)
        .subscribe(pricingPlans => {
            this.lead.pricingPlans = pricingPlans;
            for (const key in pricingPlans) {
              if (pricingPlans.hasOwnProperty(key) && (pricingPlans[key].status === 'Published')) {
                if (this.lead.selectedPricingPlan && this.lead.selectedPricingPlan === pricingPlans[key].id) {
                  this.lead.selectedPricingPlan = pricingPlans[key];
                  this.onChangePlan();
                }
              }
            }
          },
          error => {
            AlertMessageComponent.open(AlertType.Error, 'Pricing-Plans not found');
            this.errorMessage = error;
          });
    }
  }

  selectPricingTier(event) {
    console.log(event);
    this.addOnOptions = [];
    this.addOnsModel = {addOnOptions: [], addOnTypes: []};
    this.lead.selectedPricingPlan.pricingTiers.forEach(pricingTier => {
      if (pricingTier.id == event.id) {
        pricingTier.addOns.forEach(addOn => {
          this.addOnOptions.push({id: addOn.id, name: addOn.name});
        });
      }
    });
  }

  updateAddOns() {
    this.selectedAddOnItems = [];
    for (const key in this.addOnsModel.addOnOptions) {
      if (this.addOnsModel.addOnOptions.hasOwnProperty(key)) {
        this.selectedAddOnItems.push({id: this.addOnsModel.addOnOptions[key].id});
      }
    }
  }

  getCustomers(user) {
    const params = new URLSearchParams();
    params.set('id', this.lead.id);
    params.set('isRFQ', this.requestForRFQ);
    this.isUploading = true;
    this.api.get(this.endpoints.getCustomersUrl() + '?id=' + this.lead.id + '&isRFQ=' + this.requestForRFQ,
      true)
      .subscribe(customers => {
          this.lead.customers = customers;
          if (user) {
            for (const buyer in this.lead.customers) {
              if (this.lead.customers[buyer].user.id == user.id) {
                this.lead.buyer = this.lead.customers[buyer];
              }
            }
          }
          this.isUploading = false;
        },
        error => {
          this.isUploading = false;
        });
  }

  addNewCustomer() {
    this.userModal.show();
  }

  viewCustomer() {
    this.sharedService.displayBuyerSubject.next(this.lead.buyer);
    this.userDisplayModal.show();
  }

  onChangePlan() {
    this.lead.pricingTiers = [];
    if (this.lead.selectedPricingPlan.registeredResellerDisplay === 'RFQ_NO_PRICING' ||
      this.lead.selectedPricingPlan.registeredResellerDisplay === 'RFQ_DISPLAY_PRICING') {
      this.lead.vendorApprovalRequired = 'YES';
    }
    const tiers = this.lead.selectedPricingPlan.pricingTiers;
    for (const key in tiers) {
      if (tiers.hasOwnProperty(key)) {
        if (this.lead.pricingTier && this.lead.pricingTier.id === tiers[key].id) {
          this.lead.pricingTier = tiers[key];
          this.addOnOptions = [];
          this.lead.pricingTier.addOns.forEach(addOn => {
            this.addOnOptions.push({id: addOn.id, name: addOn.name});
          });

          if (this.lead.addOns) {
            this.lead.addOns.forEach(
              item => {
                if (item.id) {
                  this.addOnsModel.addOnTypes.push({id: item.id});
                } else {
                  this.addOnsModel.addOnTypes.push({id: item.id});
                }
              });
          }
        }
        this.lead.pricingTiers.push(tiers[key]);
      }
    }
  }

  onChangeBuyer() {
    this.isCustomerSelected = true;
  }

  public showModal(): void {
    this.modal.show();
  }

  public hideModal(): void {
    this.modal.hide();
  }

  public makeFormEditAble(): void {
    this.isViewOnly = false;
  }

  public hideUserModal() {
    this.userModal.hide();
  }

  public hideUserDisplayModal() {
    this.userDisplayModal.hide();
  }

  public addCreatedUser(user) {
    this.getCustomers(user);
    this.onChangeBuyer();
  }

  public isVendor() {
    return this.userService.isVendor();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/create-lead/create-lead.component.ts